import React, { useState, useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string } from "yup";
import { toast } from "react-toastify";

const validationSchema = object().shape({
  // convenience_fee: string().required("convenience fee is required"),
  // max_convenience_fee: string().required("max convenience fee is required"),
  far_delivery_gomak_fee: string().required(
    "far delivery gomak fee is required",
  ),
  snap_ryder_assignment_delay: string().required(
    "snap ryder assignment delay is required",
  ),
  in_process_expiry_time: string().required(
    "in process expiry time is required",
  ),
  new_order_expiry_time: string().required("new order expiry time is required"),
  admin_mobile_no: string().required("admin mobile no is required"),
  admin_email: string().required("admin email is required"),
  bonvoice_whatsapp_no: string().required("bonvoice whatsapp no is required"),
  agent_withdraw_limit: string().required("agent withdraw limit is required"),
  bonvoice_phone_number_id: string().required(
    "bonvoice phone number id is required",
  ),
  platform_fee: string().required("platform fee is required"),
  adhoc_order_commision: string().required(
    "Adhoc order commission is required",
  ),
  working_hour: string()
    .required("Working hour is required")
    .test(
      "valid-format",
      "Enter a valid format: '24 Hours' or HH-HH (00-23) e.g., 08-20",
      function (value) {
        if (!value) return false;

        const v = value.trim();

        // Allow "24 Hours" (case-insensitive)
        if (v.toLowerCase() === "24 hours") return true;

        // Must contain exactly one hyphen for the range format
        if (!v.includes("-")) return false;

        const parts = v.split("-");
        if (parts.length !== 2) return false;

        const [start, end] = parts.map((s) => s.trim());

        // MUST be exactly two digits and within 00-23
        const twoDigit24Regex = /^(0[0-9]|1[0-9]|2[0-3])$/;

        if (!twoDigit24Regex.test(start) || !twoDigit24Regex.test(end)) {
          return false;
        }

        const startNum = Number(start);
        const endNum = Number(end);

        // End must be greater than start (strictly)
        return endNum > startNum;
      },
    ),
  working_days: string()
    .required("Working days is required")
    .test(
      "valid-working-days",
      "Enter days in format: Mon-Tue or Mon-Tue-Wed-Thu-Fri-Sat",
      function (value) {
        if (!value) return false;

        const allowedDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

        // Split on hyphens
        const parts = value.split("-");

        // Must contain at least 2 days
        if (parts.length < 2) return false;

        // Max 7 days
        if (parts.length > 7) return false;

        // Validate each part
        for (let p of parts) {
          if (!allowedDays.includes(p)) {
            return false;
          }
        }

        return true;
      },
    ),
});

export const EditGlobalSetting = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const formik = useFormik({
    initialValues: {
      // convenience_fee: "",
      // max_convenience_fee: "",
      far_delivery_gomak_fee: "",
      snap_ryder_assignment_delay: "",
      admin_mobile_no: "",
      admin_email: "",
      bonvoice_whatsapp_no: "",
      agent_withdraw_limit: "",
      bonvoice_phone_number_id: "",
      working_hour: "",
      working_days: "",
      platform_fee: "",
      adhoc_order_commision: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const payload = {
          // convenience_fee: values.convenience_fee,
          // max_convenience_fee: values.max_convenience_fee,
          far_delivery_gomak_fee: values.far_delivery_gomak_fee,
          snap_ryder_assignment_delay: values.snap_ryder_assignment_delay,
          in_process_expiry_time: values.in_process_expiry_time,
          new_order_expiry_time: values.new_order_expiry_time,
          admin_mobile_no: values.admin_mobile_no,
          admin_email: values.admin_email,
          bonvoice_whatsapp_no: values.bonvoice_whatsapp_no,
          agent_withdraw_limit: values.agent_withdraw_limit,
          bonvoice_phone_number_id: values.bonvoice_phone_number_id,
          working_hour: values.working_hour,
          working_days: values.working_days,
          platform_fee: values.platform_fee,
          adhoc_order_commision: values.adhoc_order_commision,
        };

        const response = await axiosInstance.put(
          `/admin/internal-settings/${id}/`,
          payload,
        );
        if (response.data) {
          toast.success("Global Setting updated successfully!");
          setTimeout(() => navigate("/global-setting"), 1500);
        } else {
          toast.error("Failed to update Global Setting.");
        }
      } catch (err) {
        console.error("❌ Error updating Global Setting:", err);
        toast.error("Something went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => {
    navigate("/global-setting");
  };

  useEffect(() => {
    const fetchPricingDetails = async () => {
      try {
        const res = await axiosInstance.get(`/admin/internal-settings/${id}/`);

        if (res.data) {
          formik.setValues({
            // convenience_fee: res.data.convenience_fee?.toString() || "",
            // max_convenience_fee: res.data.max_convenience_fee?.toString() || "",
            far_delivery_gomak_fee:
              res.data.far_delivery_gomak_fee?.toString() || "",
            snap_ryder_assignment_delay:
              res.data.snap_ryder_assignment_delay?.toString() || "",
            in_process_expiry_time:
              res.data.in_process_expiry_time?.toString() || "",
            new_order_expiry_time:
              res.data.new_order_expiry_time?.toString() || "",
            admin_mobile_no: res.data.admin_mobile_no?.toString() || "",
            admin_email: res.data.admin_email || "",
            bonvoice_whatsapp_no:
              res.data.bonvoice_whatsapp_no?.toString() || "",
            agent_withdraw_limit:
              res.data.agent_withdraw_limit?.toString() || "",
            bonvoice_phone_number_id:
              res.data.bonvoice_phone_number_id?.toString() || "",
            working_hour: res.data.working_hour || "",
            working_days: res.data.working_days || "",
            platform_fee: res.data.platform_fee || "",
            adhoc_order_commision: res.data.adhoc_order_commision || "",
          });
        } else {
          toast.error("Failed to load Global Setting details.");
        }
      } catch (err) {
        console.error("❌ Error fetching Global Setting data:", err);
        toast.error("Something went wrong while loading Global Setting data.");
      }
    };

    fetchPricingDetails();
  }, [id]);

  return (
    <div className="addAdmin-container">
      <div className="addAdmin-subcontainer">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/global-setting");
          }}
        />
        <div className="add-title">Edit Global Setting</div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="addAdmin-content">
          <div className="addAdmin-contentLeft">
            {/* <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Convenience Fee
              </label>
              <div>
                <input
                  type="text"
                  name="convenience_fee"
                  placeholder="Enter Your convenience fee"
                  value={formik.values.convenience_fee}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.convenience_fee &&
                  formik.errors.convenience_fee && (
                    <div className="text-danger">
                      {formik.errors.convenience_fee}
                    </div>
                  )}
              </div>
            </div> */}
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>In Process Expiry Time
              </label>
              <div>
                <input
                  type="number"
                  name="in_process_expiry_time"
                  placeholder="Enter Your far in process expiry time"
                  value={formik.values.in_process_expiry_time}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.in_process_expiry_time &&
                  formik.errors.in_process_expiry_time && (
                    <div className="text-danger">
                      {formik.errors.in_process_expiry_time}
                    </div>
                  )}
              </div>
            </div>

            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Snap Ryder Assignment
                Delay In seconds
              </label>
              <div>
                <input
                  type="text"
                  name="snap_ryder_assignment_delay"
                  placeholder="Enter Your snap ryder assignment delay"
                  value={formik.values.snap_ryder_assignment_delay}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.snap_ryder_assignment_delay &&
                  formik.errors.snap_ryder_assignment_delay && (
                    <div className="text-danger">
                      {formik.errors.snap_ryder_assignment_delay}
                    </div>
                  )}
              </div>
            </div>

            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Admin Email
              </label>
              <div>
                <input
                  type="text"
                  name="admin_email"
                  placeholder="Enter Your admin email"
                  value={formik.values.admin_email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.admin_email && formik.errors.admin_email && (
                  <div className="text-danger">{formik.errors.admin_email}</div>
                )}
              </div>
            </div>

            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Agent Withdraw Limit
              </label>
              <div>
                <input
                  type="text"
                  name="agent_withdraw_limit"
                  placeholder="Enter Your agent withdraw limit"
                  value={formik.values.agent_withdraw_limit}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.agent_withdraw_limit &&
                  formik.errors.agent_withdraw_limit && (
                    <div className="text-danger">
                      {formik.errors.agent_withdraw_limit}
                    </div>
                  )}
              </div>
            </div>

            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Bonvoice Phone Number ID
              </label>
              <div>
                <input
                  type="text"
                  name="bonvoice_phone_number_id"
                  placeholder="Enter Your bonvoice phone number id"
                  value={formik.values.bonvoice_phone_number_id}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.bonvoice_phone_number_id &&
                  formik.errors.bonvoice_phone_number_id && (
                    <div className="text-danger">
                      {formik.errors.bonvoice_phone_number_id}
                    </div>
                  )}
              </div>
            </div>

            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Working Days
              </label>
              <div>
                <input
                  type="text"
                  name="working_days"
                  placeholder="e.g., Mon-Tue-Wed-Thu-Fri-Sat"
                  value={formik.values.working_days}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <p
                  className="text-muted"
                  style={{ fontSize: "12px", marginTop: "4px" }}
                >
                  Example: <strong>Mon-Tue</strong> or{" "}
                  <strong>Mon-Tue-Wed-Thu-Fri-Sat</strong>
                </p>
                {formik.touched.working_days && formik.errors.working_days && (
                  <div className="text-danger">
                    {formik.errors.working_days}
                  </div>
                )}
              </div>
            </div>
            <div className="addAdmin-field">
              <span className="text-danger">*</span>
              <label>Adhoc Order Commission</label>
              <div>
                <input
                  type="number"
                  min={1}
                  name="adhoc_order_commision"
                  placeholder="Enter Your Adhoc Order Commission"
                  value={formik.values.adhoc_order_commision}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.adhoc_order_commision &&
                  formik.errors.adhoc_order_commision && (
                    <div className="text-danger">
                      {formik.errors.adhoc_order_commision}
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div className="addAdmin-contentRight">
            {/* <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Max Convenience Fee
              </label>
              <div>
                <input
                  type="number"
                  name="max_convenience_fee"
                  placeholder="Enter Your max convenience fee"
                  value={formik.values.max_convenience_fee}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.max_convenience_fee &&
                  formik.errors.max_convenience_fee && (
                    <div className="text-danger">
                      {formik.errors.max_convenience_fee}
                    </div>
                  )}
              </div>
            </div> */}

            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Far Delivery Gomak Fee
              </label>
              <div>
                <input
                  type="number"
                  name="far_delivery_gomak_fee"
                  placeholder="Enter Your far delivery gomak fee"
                  value={formik.values.far_delivery_gomak_fee}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.far_delivery_gomak_fee &&
                  formik.errors.far_delivery_gomak_fee && (
                    <div className="text-danger">
                      {formik.errors.far_delivery_gomak_fee}
                    </div>
                  )}
              </div>
            </div>

            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>New Order Expiry Time
              </label>
              <div>
                <input
                  type="text"
                  name="new_order_expiry_time"
                  placeholder="Enter Your new order expiry time"
                  value={formik.values.new_order_expiry_time}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.new_order_expiry_time &&
                  formik.errors.new_order_expiry_time && (
                    <div className="text-danger">
                      {formik.errors.new_order_expiry_time}
                    </div>
                  )}
              </div>
            </div>

            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Admin Mobile No
              </label>
              <div>
                <input
                  type="text"
                  name="admin_mobile_no"
                  placeholder="Enter Your admin mobile no"
                  value={formik.values.admin_mobile_no}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.admin_mobile_no &&
                  formik.errors.admin_mobile_no && (
                    <div className="text-danger">
                      {formik.errors.admin_mobile_no}
                    </div>
                  )}
              </div>
            </div>

            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Bonvoice Whatsapp No
              </label>
              <div>
                <input
                  type="text"
                  name="bonvoice_whatsapp_no"
                  placeholder="Enter Your bonvoice whatsapp no"
                  value={formik.values.bonvoice_whatsapp_no}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.bonvoice_whatsapp_no &&
                  formik.errors.bonvoice_whatsapp_no && (
                    <div className="text-danger">
                      {formik.errors.bonvoice_whatsapp_no}
                    </div>
                  )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>platform Fee
              </label>
              <div>
                <input
                  type="number"
                  name="platform_fee"
                  placeholder="Enter Platform Fee"
                  value={formik.values.platform_fee}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.platform_fee && formik.errors.platform_fee && (
                  <div className="text-danger">
                    {formik.errors.platform_fee}
                  </div>
                )}
              </div>
            </div>

            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Working Hour
              </label>
              <div>
                <input
                  type="text"
                  name="working_hour"
                  placeholder="24 Hours e.g., 10–8"
                  value={formik.values.working_hour}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <p
                  className="text-muted"
                  style={{ fontSize: "12px", marginTop: "4px" }}
                >
                  Example:
                  <strong>24 Hours</strong> formate e.g.. <strong>10-8</strong>
                </p>
                {formik.touched.working_hour && formik.errors.working_hour && (
                  <div className="text-danger">
                    {formik.errors.working_hour}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="addbtnContainer">
          <div>
            <button
              type="button"
              className="admin-btnCancel"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
          <div>
            <button className="add-btnSave" type="submit">
              Update
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
